import React from 'react';

import Loadable from '@townsquare/loadable';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { TeamsAppForYouSkeleton } from './TeamsAppForYouSkeleton';
import { teamsAppForYouAGGResource } from './resources/teamsAppForYouAGGResource';
import { teamsAppForYouWatermelonResource } from './resources/teamsAppForYouWatermelonResource';

const TeamsAppForYouLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "TeamsAppForYou" */ './TeamsAppForYouWithResource'),
	loading: () => <TeamsAppForYouSkeleton showKudos={false} />,
	delay: 0,
});

teamsAppForYouRoute.component = TeamsAppForYouLoadable;
teamsAppForYouRoute.resources = [
	teamsAppForYouAGGResource,
	teamsAppForYouWatermelonResource,
	rovoEntitlementResource,
];

export const teamsAppForYouRouterRoute = teamsAppForYouRoute;
